import { Injectable } from '@angular/core';
import { NgxZendeskWebwidgetConfig } from './ngx-zendesk-webwidget.model';

function getWindow(): any {
  return window;
}

@Injectable({
  providedIn: 'root',
})
export class NgxZendeskWebwidgetService {
  private readonly window: any;
  private initialized = false;
  private _zE: any;

  constructor(private ngxZendeskWebwidgetConfig: NgxZendeskWebwidgetConfig) {
    if (!this.ngxZendeskWebwidgetConfig.accountUrl) {
      throw new Error(
        'Missing accountUrl. Please set in app config via ZendeskWidgetProvider',
      );
    }

    this.window = getWindow();

    if (!this.ngxZendeskWebwidgetConfig.lazyLoad) {
      this.initZendesk();
    }
  }

  public initZendesk(): Promise<boolean> {
    const window = this.window;
    const config = this.ngxZendeskWebwidgetConfig;

    // tslint:disable
    window.zEmbed ||
      (function (e, t) {
        // eslint-disable-next-line
        // @ts-ignore
        let n;
        let o;
        let d;
        // eslint-disable-next-line
        // @ts-ignore
        const a = [];
        const r = document.createElement('iframe');
        window.zEmbed = function () {
          // eslint-disable-next-line
          a.push(arguments);
        };
        window.zE = window.zE || window.zEmbed;
        r.src = 'javascript:false';
        r.title = '';
        r.style.cssText = 'display: none';
        d = document.getElementsByTagName(config.injectionTag || 'head');
        d = d[d.length - 1];
        // eslint-disable-next-line
        // @ts-ignore
        d.parentNode.insertBefore(r, d);
        // eslint-disable-next-line
        // @ts-ignore
        const i = r.contentWindow;
        // eslint-disable-next-line
        // @ts-ignore
        const s = i.document;
        try {
          o = s;
        } catch (e) {
          n = document.domain;
          r.src = `javascript:var d=document.open();d.domain="${n}";void(0);`;
          o = s;
        }

        // this ignored because it is a copy of the zendesk script and run on
        // javascript environment not typescript
        // eslint-disable-next-line
        // @ts-ignore
        o.open()._l = function () {
          const e = this.createElement('script');
          // eslint-disable-next-line
          // @ts-ignore
          n && (this.domain = n);
          e.id = 'js-iframe-async';
          e.src = 'https://static.zdassets.com/ekr/snippet.js';
          // eslint-disable-next-line
          // @ts-ignore
          this.t += new Date();
          // eslint-disable-next-line
          // @ts-ignore
          this.zendeskHost = config.accountUrl;
          // eslint-disable-next-line
          // @ts-ignore
          this.zEQueue = a;
          this.body.appendChild(e);
        };
        o.write('<body onload="document._l();">');
        o.close();
      })();

    return this.finishLoading();
  }

  private finishLoading(): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      const timeout = setTimeout(() => {
        this.initialized = false;
        reject(Error('timeout'));
      }, this.ngxZendeskWebwidgetConfig.timeOut || 30000); // 30 seconds

      this.window.zE(() => {
        this.ngxZendeskWebwidgetConfig.callback(this.window.zE);
        this.initialized = true;
        this._zE = this.window.zE;
        clearTimeout(timeout);
        resolve(true);
      });
    });
  }

  get isInitialized(): boolean {
    return this.initialized;
  }

  get zE(): any {
    return this._zE;
  }
}
